export const PRIVATE_PARTY_PAGE_NAMES = {
  PRIVATE_PARTY_CREATE_LISTING: 'private_party_create_listing',
  PRIVATE_PARTY_CREATE_LISTING_VEHICLE_DETAILS: 'private_party_create_listing_vehicle_details',
  PRIVATE_PARTY_CREATE_LISTING_PRICE: 'private_party_create_listing_price',
  PRIVATE_PARTY_CREATE_LISTING_PHOTOS: 'private_party_create_listing_photos',
  PRIVATE_PARTY_CREATE_LISTING_SELLER: 'private_party_create_listing_seller',
  PRIVATE_PARTY_CREATE_LISTING_PREVIEW: 'private_party_create_listing_preview',
};
